import React, {Component} from 'react';
import './form-inputs.css';

export default class FormInputs extends Component {

  constructor(props) {
    super(props);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
  }

  handleNameChange(e) {
    this.props.changeName(e.target.value);
  }

  handleCommentChange(e) {
    this.props.changeComment(e.target.value);
  }

  render() {
    return (
      <section className="FormInputs">
        <div>
          <label htmlFor="FormInputs__name">
            Your name:<span> (optional)</span>
          </label>
          <input
            type="text"
            id="FormInputs__name"
            className="FormInputs__name"
            placeholder="Enter a name (optional)"
            value={this.props.newReview.name}
            onChange={this.handleNameChange}
          />
        </div>
        <div>
          <label htmlFor="FormInputs__comment">
            An additional comment:<span> (optional)</span>
          </label>
          <textarea
            id="FormInputs__comment"
            className="FormInputs__comment"
            placeholder="Enter a comment (optional)"
            value={this.props.newReview.comment}
            onChange={this.handleCommentChange}
          />
        </div>
        <div>
          <button
            className="FormInputs__submit"
            type="submit"
          >Submit</button>
        </div>
      </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/reviews/new/form-inputs.js